import React, { useContext, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import MainContext from 'store/MainContext';
import API from 'api/axios';
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import checkMobilePhone from '../../fns/checkMobilePhone';
import toEN from '../../fns/toEn';
import useTitle from 'hooks/useTitle';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  title: {
    marginTop: theme.spacing(2),
    textAlign: 'center',
  },
  center: {
    textAlign: 'center',
  },
}));

const Forget = (props) => {
  useTitle('فراموشی رمز عبور');
  const classes = useStyles();
  const defaultVerficationTimout = 60;
  const mainState = useContext(MainContext);
  const { title, logo } = mainState.publicSettings;
  const [isLoaded, setIsLoaded] = useState(true);
  const [mobile, setMobile] = useState('');
  const [verification, setVerification] = useState('');
  const [step, setStep] = useState(1);
  const [password, setPassword] = useState('');
  let [count, setCount] = useState(defaultVerficationTimout);

  useEffect(() => {
    if (step === 2) {
      if (count > 0) {
        setTimeout(() => {
          setCount(count - 1);
        }, 1000);
      } else {
        setCount(defaultVerficationTimout);
        setStep(1);
      }
    }
  }, [count]);

  const handleSendVerfication = (e) => {
    e.preventDefault();
    setIsLoaded(false);
    if (step === 2) {
      API('/auth/user/rstpwdbyvcode', {
        method: 'put',
        data: {
          mobilePhone: mobile,
          verificationCode: verification,
          newPassword: password,
        },
      })
        .then((res) => {
          //const msg = res.data.messages.map((value,index)=>(<li key={index}>{value}</li>))
          const msg = 'رمز با موفقیت تغیر کرد';
          props.handleNotification(1, 'tl', 'موفقیت آمیز', msg);
          localStorage.setItem('loged', true);
          mainState.LogIn();
        })
        .catch((er) => {
          console.error(er);
          if (er.response.data !== undefined || er.response.data !== null) {
            const msg = er.response.data.messages.map((value, index) => (
              <li key={index}>{value}</li>
            ));
            props.handleNotification(3, 'tl', 'خطا', msg);
            setIsLoaded(true);
          }
        });
    } else {
      API('/auth/user/fpwdmobile', {
        method: 'post',
        data: {
          mobilePhone: mobile,
        },
      })
        .then((res) => {
          const msg = res.data.messages.map((value, index) => (
            <li key={index}>{value}</li>
          ));
          props.handleNotification(1, 'tl', 'ارسال شد', msg);
          setStep(2);
          setIsLoaded(true);
          setCount(count - 1);
        })
        .catch((er) => {
          if (er.response.status) {
            const msg = er.response.data.messages.map((value, index) => (
              <li key={index}>{value}</li>
            ));
            props.handleNotification(3, 'tl', 'خطا', msg);
            setIsLoaded(true);
          }
        });
    }
  };

  const handleChangeMobilePhone = (e) => {
    let number = e.target.value;
    number = toEN(number);
    const mobilePhone = checkMobilePhone(number);
    setMobile(!!mobilePhone ? mobilePhone : number);
  };
  const handleChangeVerficationCode = (e) => {
    let verificationCode = e.target.value;
    verificationCode = toEN(verificationCode);
    setVerification(verificationCode);
  };
  const handleChangePassword = (e) => {
    setPassword(e.target.value);
  };

  const formLabel =
    step === 1
      ? ' جهت بازیابی رمز عبور خود شماره موبایل خود را وارد کنید:'
      : '  کد فعالسازی برای شما ارسال شد!';

  const formButton =
    step === 1 ? (
      <Button
        variant="contained"
        color="secondary"
        size="large"
        disabled={!isLoaded}
        onClick={handleSendVerfication}
      >
        {isLoaded ? 'دریافت کد' : 'صبر کنید ...'}
      </Button>
    ) : (
      <Button
        variant="contained"
        color="secondary"
        size="large"
        disabled={!isLoaded}
        onClick={handleSendVerfication}
      >
        {isLoaded ? 'تغییر رمز عبور' : 'صبر کنید ...'}
      </Button>
    );

  const mobileOnVerfication = step === 1 ? false : true;

  const counterText =
    step === 1 ? (
      ''
    ) : (
      <p className="verfication-counter">
        شما <span>{count}</span> ثانیه برای وارد کردن کد تائید پیامک شده زمان
        دارید.
      </p>
    );
  const verificationText =
    step === 1 ? (
      ''
    ) : (
      <>
        <TextField
          variant="outlined"
          fullWidth
          value={verification}
          onChange={handleChangeVerficationCode}
          label="کدفعالسازی پیامک شده:"
        />
        <TextField
          variant="outlined"
          type="password"
          fullWidth
          value={password}
          onChange={handleChangePassword}
          label="گذرواژه جدید"
        />
      </>
    );

  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justify="center"
      style={{ minHeight: '100vh' }}
    >
      <Container maxWidth="sm">
        <form onSubmit={handleSendVerfication}>
          <Paper>
            <Grid
              container
              direction="column"
              justify="center"
              alignItems="stretch"
              className={classes.root}
              spacing={2}
            >
              <Grid item className={classes.title}>
                <Link to="/login">
                  <img src={logo} height="100" alt="لوگو سامانه حمل بار" />
                </Link>
                <Link to="/login">
                  <h1>{title}</h1>
                </Link>
              </Grid>
              <Grid item className={classes.center}>
                <TextField
                  variant="outlined"
                  onChange={handleChangeMobilePhone}
                  label={formLabel}
                  value={mobile}
                  fullWidth
                />
              </Grid>
              <Grid item className={classes.center}>
                {verificationText}
              </Grid>
              <Grid item className={classes.center}>
                {counterText}
              </Grid>
              <Grid item className={classes.center}>
                {formButton}
              </Grid>

              <Grid item className={classes.center}>
                <Link to="/login">بازگشت به صفحه ورود</Link>
              </Grid>
            </Grid>
          </Paper>
        </form>
      </Container>
    </Grid>
  );
};

export default Forget;
